import { create } from 'zustand';

export const useUserConfigFormStore = create((set) => ({
  formData: {
    fixUserConfigMappingId: null,
    venueId: '',
    userId: '',
    venueUser: '',
  },
  fieldErrors: {},
  loading: false,
  error: null,

  setFormData: (data) => set((state) => ({
    formData: { ...state.formData, ...data }
  })),

  setFieldErrors: (errors) => set({ fieldErrors: errors }),

  clearFieldError: (fieldName) => set((state) => ({
    fieldErrors: {
      ...state.fieldErrors,
      [fieldName]: false
    }
  })),

  clearFieldErrors: () => set({ fieldErrors: {} }),

  setLoading: (loading) => set({ loading }),

  setError: (error) => set({ error }),

  resetFormData: () => set({
    formData: {
      fixUserConfigMappingId: null,
      venueId: '',
      userId: '',
      venueUser: '',
    },
    fieldErrors: {},
    loading: false,
    error: null,
  }),
}));
